var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20c0-3.314 3.582-6 8-6s8 2.686 8 6v1H4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonfill);
export default __webpack_public_path__ + "static/media/person.fill.91b58ad398ea12e074afe7564ffd1458.svg";
export { ForwardRef as ReactComponent };